import { EPaymentInitSource } from '../../types/microfrontends/paymentWidget';

export interface ICustomState {
  paymentInitSource: EPaymentInitSource | null;
  packageType: ECustomDataPackageType | null;
}

export enum ECustomDataPackageType {
  Package = 'package',
  CustomPackage = 'customPackage',
  Subscription = 'subscription',
}
